import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function ResumeAnalysisSkeleton({ isDarkMode }) {
    const cardCls = `rounded-2xl border shadow-sm ${isDarkMode ? "bg-slate-800 border-slate-700" : "bg-white border-slate-200"}`;
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            <div className={`min-h-screen w-full ${isDarkMode ? "bg-surface" : "bg-surface"}`}>
                <div className="max-w-7xl mx-auto px-4 py-8">
                    <Skeleton width={200} height={28} className="mb-6" />

                    {/* Tabs */}
                    <div className="flex gap-2 mb-6">
                        <Skeleton width={140} height={40} borderRadius={8} />
                        <Skeleton width={140} height={40} borderRadius={8} />
                    </div>

                    {/* Info banner */}
                    <Skeleton height={48} borderRadius={12} className="mb-6" />

                    {/* Usage counter */}
                    <div className="flex justify-end mb-4">
                        <Skeleton width={220} height={14} />
                    </div>

                    {/* Select Resume card */}
                    <section className="mb-8">
                        <div className={`${cardCls} p-6`}>
                            <Skeleton width={150} height={22} className="mb-4" />
                            <Skeleton height={48} borderRadius={8} className="mb-3" />
                            <Skeleton height={48} borderRadius={8} />
                        </div>
                    </section>

                    {/* Job Description card */}
                    <section className="mb-8">
                        <div className={`${cardCls} p-6`}>
                            <Skeleton width={170} height={22} className="mb-4" />
                            <Skeleton width={220} height={16} className="mb-2" />
                            <Skeleton height={44} borderRadius={8} className="mb-4" />
                            <Skeleton height={140} borderRadius={8} className="mb-4" />
                            <Skeleton width={160} height={44} borderRadius={8} />
                        </div>
                    </section>
                </div>
            </div>
        </SkeletonTheme>
    );
}
